export function compareElements(
  el1: HTMLElement,
  el2: HTMLElement,
  excludeAttributes: string[] = [],
): boolean {
  // Check if both elements are valid and of the same tag name
  if (!el1 || !el2 || el1.tagName !== el2.tagName) {
    return false;
  }

  // Helper to filter attributes
  const getFilteredAttributes = (
    attrs: NamedNodeMap,
  ): Record<string, string> => {
    const filtered: Record<string, string> = {};
    for (let i = 0; i < attrs.length; i++) {
      const attr = attrs[i];
      if (!excludeAttributes.includes(attr.name)) {
        filtered[attr.name] = attr.value;
      }
    }
    return filtered;
  };

  // Compare attributes (excluding specified ones)
  const filteredAttrs1 = getFilteredAttributes(el1.attributes);
  const filteredAttrs2 = getFilteredAttributes(el2.attributes);

  const keys1 = Object.keys(filteredAttrs1);
  const keys2 = Object.keys(filteredAttrs2);

  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (filteredAttrs1[key] !== filteredAttrs2[key]) {
      return false;
    }
  }

  // Compare text content (if only text)
  const isOnlyText1 =
    el1.childNodes.length === 1 &&
    el1.childNodes[0].nodeType === Node.TEXT_NODE;
  const isOnlyText2 =
    el2.childNodes.length === 1 &&
    el2.childNodes[0].nodeType === Node.TEXT_NODE;

  if (isOnlyText1 && isOnlyText2) {
    if (el1.textContent?.trim() !== el2.textContent?.trim()) {
      return false;
    }
  }

  // Compare child elements recursively
  const children1 = el1.children;
  const children2 = el2.children;

  if (children1.length !== children2.length) return false;

  for (let i = 0; i < children1.length; i++) {
    if (
      !compareElements(
        children1[i] as HTMLElement,
        children2[i] as HTMLElement,
        excludeAttributes,
      )
    ) {
      return false;
    }
  }

  return true;
}
